module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent branch-offices-page"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('a', {
    class: [_vm.activetab === 1 ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activetab = 1
      }
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    class: [_vm.activetab === 2 ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activetab = 2
      }
    }
  }, [_vm._v("Contacts")]), _vm._v(" "), _c('a', {
    class: [_vm.activetab === 3 ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activetab = 3
      }
    }
  }, [_vm._v("News Notes")]), _vm._v(" "), _c('a', {
    class: [_vm.activetab === 4 ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activetab = 4
      }
    }
  }, [_vm._v("Announcements")]), _vm._v(" "), _c('a', {
    class: [_vm.activetab === 6 ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activetab = 6
      }
    }
  }, [_vm._v("Main Page")]), _vm._v(" "), _c('a', {
    class: [_vm.activetab === 7 ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activetab = 7
      }
    }
  }, [_vm._v("Center Page")])]), _vm._v(" "), (_vm.activetab === 1) ? _c('div', [_vm._m(0), _vm._v(" "), _c('about', {
    attrs: {
      "entity": _vm.entity
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activetab === 2) ? _c('div', [_vm._m(1), _vm._v(" "), _c('contacts', {
    attrs: {
      "entity": _vm.entity,
      "source": _vm.source
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activetab === 3) ? _c('div', [_vm._m(2), _vm._v(" "), _c('news')], 1) : _vm._e(), _vm._v(" "), (_vm.activetab === 4) ? _c('div', [_vm._m(3), _vm._v(" "), _c('announcements')], 1) : _vm._e(), _vm._v(" "), (_vm.activetab === 6) ? _c('div', [_vm._m(4), _vm._v(" "), _c('main-page', {
    attrs: {
      "entity": _vm.entity,
      "source": _vm.source
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activetab === 7) ? _c('div', [_vm._m(5), _vm._v(" "), _c('center-page', {
    attrs: {
      "entity": _vm.entity,
      "source": _vm.source
    }
  })], 1) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("About")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Contacts")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("News Notes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Announcements")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Main Page")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Center Page")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74fdc38c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/branchOffices/Edit.vue
// module id = 946
// module chunks = 0